<app-page>
    <app-location-header [locationId]="locationId"></app-location-header>
    <div>
        <table>
            <tr>
                <td>
                    <app-action [text]="'add' | translate" [defaultStyle]=true (onExecute)="goToAddPointOfServicePage()"></app-action>
                </td>
                <td>
                    <app-action [text]="'add_multiple' | translate" [defaultStyle]=true (onExecute)="goToAddPointsOfServicePage()"></app-action>
                </td>
                <td>
                    <app-action [text]="'go_to_location' | translate" [defaultStyle]=true (onExecute)="goToLocationPage()"></app-action>
                </td>
            </tr>
        </table>
    </div>
    <app-location-points-of-service [locationId]="locationId"></app-location-points-of-service>
</app-page>
